
class SearchAciton
  constructor: ->
    @init()

  init: ->
    @flg = true
    @searchArea = $('.header_search')
    @searchOpenBtn = $('.header_userMenu.header_userMenu-search .pointer')

    @searchOpenBtn.on 'click', @switchSearchBox

  switchSearchBox: =>
    if @flg
      @flg = false
      if @searchOpenBtn.hasClass('active')
        @closeSearchBox()
        @searchOpenBtn.removeClass 'active'
      else
        @openSearchBox()
        @searchOpenBtn.addClass 'active'


  openSearchBox: =>
    self = @
    @searchArea.slideDown(300, ->
      self.flg = true
      return)

  closeSearchBox: =>
    self = @
    @searchArea.slideUp(300, ->
      self.flg = true
      return)


module.exports = SearchAciton



// WEBPACK FOOTER //
// ./src/scripts/modules/SearchAction.coffee